<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <h2>
        <slot name="header">
          Default Slots
        </slot>
        <v-chip class="ma-2" :color="chipColor" text-color="white" small>
          {{ level }}
        </v-chip>
      </h2>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <slot name="content"> Expansion panel content for Default Slots </slot>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: "expansion-pnl",
  mixins: [],
  created() {},
  data: () => ({}),
  components: {},
  props: {
    level: { type: String, default: "basic" },
  },
  watch: {},
  computed: {
    chipColor: function() {
      return this.level === "basic" ? "green" : "red";
    },
  },
  methods: {},
};
</script>

<style></style>
